module.exports = __webpack_public_path__ + "img/free-trial.97909f9d.jpg";